var map = {
	"./de-de.js": [
		"./src/lang-resources/de-de.js",
		[
			"lang-de-de-js"
		]
	],
	"./en-in.js": [
		"./src/lang-resources/en-in.js",
		[
			"lang-en-in-js"
		]
	],
	"./en-us.js": [
		"./src/lang-resources/en-us.js",
		[]
	],
	"./es-es.js": [
		"./src/lang-resources/es-es.js",
		[
			"lang-es-es-js"
		]
	],
	"./fr-fr.js": [
		"./src/lang-resources/fr-fr.js",
		[
			"lang-fr-fr-js"
		]
	],
	"./id.js": [
		"./src/lang-resources/id.js",
		[
			"lang-id-js"
		]
	],
	"./it-it.js": [
		"./src/lang-resources/it-it.js",
		[
			"lang-it-it-js"
		]
	],
	"./ja.js": [
		"./src/lang-resources/ja.js",
		[
			"lang-ja-js"
		]
	],
	"./ko.js": [
		"./src/lang-resources/ko.js",
		[
			"lang-ko-js"
		]
	],
	"./lt-lt.js": [
		"./src/lang-resources/lt-lt.js",
		[
			"lang-lt-lt-js"
		]
	],
	"./nl-be.js": [
		"./src/lang-resources/nl-be.js",
		[
			"lang-nl-be-js"
		]
	],
	"./pt-br.js": [
		"./src/lang-resources/pt-br.js",
		[
			"lang-pt-br-js"
		]
	],
	"./ru-ru.js": [
		"./src/lang-resources/ru-ru.js",
		[
			"lang-ru-ru-js"
		]
	],
	"./sv-se.js": [
		"./src/lang-resources/sv-se.js",
		[
			"lang-sv-se-js"
		]
	],
	"./tr.js": [
		"./src/lang-resources/tr.js",
		[
			"lang-tr-js"
		]
	],
	"./zh-hans-cn.js": [
		"./src/lang-resources/zh-hans-cn.js",
		[
			"lang-zh-hans-cn-js"
		]
	],
	"./zh-hant-tw.js": [
		"./src/lang-resources/zh-hant-tw.js",
		[
			"lang-zh-hant-tw-js"
		]
	],
	"./zh-hk.js": [
		"./src/lang-resources/zh-hk.js",
		[
			"lang-zh-hk-js"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/lang-resources lazy recursive ^\\.\\/.*\\.js$ referencedExports: default";
module.exports = webpackAsyncContext;